import { BREAKPOINT_CHANGED } from '../actionTypes';

export const breakpointChanged = (breakpoint) => ({
  type: BREAKPOINT_CHANGED,
  payload: breakpoint,
});
